<template>
  <section class="group">
    <div class="card" style="border-radius: 8px;box-shadow: none">
      <div class="card-header">
        <div class="group-menu">
          <div class="group-menu__header">
            <p
              class="card-header-title is-semibold-16-600-19"
            v-tooltip="{ content: group[0].groupName }"
            >
              <!-- <span class="flyto-btn">
                <i class="far fa-paper-plane"></i>
              </span> -->
              {{group[0].groupName | truncate(20) }}
            </p>
            <a class="card-header-icon" @click="open=!open">
              <svg  viewBox="0 0 100 100" class="image is-24x24">
                <use v-if="!open" xlink:href="@/assets/sprite.svg#collapse" />
                <use v-else xlink:href="@/assets/sprite.svg#expand" />
              </svg>
              <!-- <img v-else class="mr-10" src="@/assets/icons/caret-active.svg" alt /> -->
            </a>
          </div>
        </div>
      </div>
      <div :class="{'card-content-close':!open}" class="card-content">
        <project v-for="project in sort(group)" :key="project.projectUid" :project="project"></project>
      </div>
    </div>
  </section>
</template>
<script>
import Project from "./project.component";
export default {
  components: {
    project: Project
  },
  data(){
    return {
      open: false
    }
  },
  props: ["group"],
  methods: {
    sort(data) {
      if (!data) return [];
      return _.sortBy(data, [p => p.projectName.toLowerCase()]);
    }
  }
};
</script>
<style lang="scss" scoped>
.flyto-btn {
  cursor: pointer;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  color:#555c7e;
}
.group {
  margin : 1rem 1.4rem;
  border-radius: 10px;
  box-shadow: 0 3px 6px 0 rgba(92, 126, 247, 0.3);
  .card-header-title {
    margin: 0;
    cursor: pointer;
    text-align: left;
    padding: 0.5rem;
  }
  .active {
    color: #000;
    font-weight: 500;
  }
  .card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-left: 0.2rem;
    transition: all 0.3s;
    &-close {
      display: none;
    }
  }
  .is-checkradio[type="checkbox"].is-small + label {
    font-size: 14px;
    font-family: Barlow-Medium;
    line-height: 42px;
    font-weight: 500;
    opacity: 0.7;
    color: #171e48;
  }
  .is-checkradio[type="checkbox"].is-small + label::before,
  .is-checkradio[type="checkbox"].is-small + label:before {
    margin-top: 3px;
  }
  .is-checkradio[type="checkbox"].is-small + label::after,
  .is-checkradio[type="checkbox"].is-small + label:after {
    top: 0.40375rem;
  }
}
.group-menu {
  width: 100%;
  &__header {
    user-select: none;
    display: flex;
    justify-content: space-between;
  }
  &__content {
    padding: 0 0.5rem;
    &-row {
      display: flex;
      justify-content: flex-start;
    }
  }
}
</style>
